import { render, staticRenderFns } from "./ProjectStatistics.vue?vue&type=template&id=7e570224"
import script from "./ProjectStatistics.vue?vue&type=script&lang=js"
export * from "./ProjectStatistics.vue?vue&type=script&lang=js"
import style0 from "./ProjectStatistics.vue?vue&type=style&index=0&id=7e570224&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports